import { render, staticRenderFns } from "./TimberCategorySettings.vue?vue&type=template&id=59751bd4&"
import script from "./TimberCategorySettings.vue?vue&type=script&lang=js&"
export * from "./TimberCategorySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports